import { Injectable } from '@angular/core';
import { TransactionOverrideService } from './transaction-override.service';
import { ISourceSystemType } from '../../../foundation/models/enums/source-system-type.enum';
import { BusinessTransactionMetaData } from '../../models/business-transaction/business-transaction-metadata.model';

@Injectable()
export class AircraftTransactionOverrideService extends TransactionOverrideService {
    /**
     * Determines if the route should be overriden with a new business transaction.  If so, a new transaction
     * number will be passed back.  If the transaction should not be overridden, the original transaction number
     * will be returned.
     */
    public async getTransactionNumber(businessTransactionNumberId: number, metaData: BusinessTransactionMetaData): Promise<number> {
        return businessTransactionNumberId;
    }

    public get sourceSystemType(): ISourceSystemType {
        return this.sourceSystemTypes.Aircraft;
    }
}
